import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UserModel, UserServerModel } from '@domain/entities/user.model';
import { GeneralResult } from '@domain/entities/general';

export abstract class UsersGateway {
    abstract read(
        params?: HttpParams
    ): Observable<GeneralResult<UserServerModel>>;
    abstract create(form: UserModel): Observable<UserServerModel>;
    abstract readById(id: number): Observable<UserServerModel>;
    abstract update(id: number, form: UserModel): Observable<UserServerModel>;
    abstract delete(id: number): Observable<UserServerModel>;
}
